<template>
  <el-dialog title="Добавление доступа к камере" :visible="visible" v-on="$listeners" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item label="Клиент">
        <select-client
          :owner-id="recipient.id_recipient"
          :with-cross-shared="true"
          :camera-id="cameraId"
          @change="(client) => (recipient.id_recipient = client.id_account)"
        />
      </el-form-item>
      <el-form-item label="Доступ к архиву">
        <el-switch v-model="recipient.is_access_archive" />
      </el-form-item>
      <el-form-item label="Звук">
        <el-switch v-model="recipient.is_access_sound" />
      </el-form-item>
      <el-form-item label="События Push">
        <el-switch v-model="recipient.is_notify_by_push" />
      </el-form-item>
      <el-form-item label="События Telegram">
        <el-switch v-model="recipient.is_notify_by_telegram" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="requestLoading" type="primary" @click="onSave">
        Предоставить доступ
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import SelectClient from "@/core/components/features/SelectClient";
import { mapActions } from "vuex";
export default {
  name: "CameraRecipientCreateModal",
  components: { SelectClient },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    cameraId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      requestLoading: false,
      recipient: {
        id_recipient: null,
        is_access_archive: false,
        is_access_sound: false,
        is_notify_by_push: false,
        is_notify_by_telegram: false,
      },
    };
  },
  methods: {
    ...mapActions("cameras", {
      addRecipient: "ADD_CAMERA_RECIPIENT",
    }),
    onSave() {
      this.addRecipient({ id_camera: this.cameraId, ...this.recipient }).then(() => {
        this.$message.success("Доступ добавлен");
        this.$emit("update:visible", false);
        this.$root.$emit("camera-sharing-history-refresh");
      });
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
